export default "__VITE_ASSET__af6b7d76__"